import styles from './center-image.module.less';
import Image from '../image/Image';

const CenterImage = ({ image, altText }) => {
    return <Image src={image} alt={altText} className={styles.img} />;
};

export default CenterImage;
